/*
 * SashiDo
 * All rights reserved.
 */

import React from 'react';
import Button from 'components/Button/Button.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import styles from './Billing.scss';
import history from 'dashboard/history';
import settingsStyles from 'dashboard/Settings/Settings.scss';
import PreLoader from 'components/PreLoader/PreLoader.react';
import Fieldset from 'components/Fieldset/Fieldset.react';
import AppsManager from 'lib/AppsManager';
import AppBillingDetails from './AppBillingDetails.react';
import * as formatter from 'lib/formatter';

import { addonTitles } from 'lib/Constants';

import stylesEngine from 'dashboard/Runtime/EngineView.scss';


export default class AppsDetails extends React.Component {
  constructor(props) {
    super();

    this.subsection = props.section

    this.state = {
      loading: true,
      appsStats: {
        stats: {}
      },
      toolbarSubsection: '',
      country: ''
    }
  }

  componentDidMount() {
    let promiseList = [];

    let appsStats = AppsManager.stats().then((response) => {
      return { appsStats: response.appsStats };
    });

    promiseList.push(appsStats);

    return Promise.all(promiseList).then((data) => {
      let state = { loading: false };

      data.forEach((item) => {
        if (item.appsStats) {
          state.appsStats = item.appsStats;
        }
      });

      this.setState(state);
    });
  }

  onCloseClick() {
    //go to billing
    history.push(`/billing/info`);
  }

  render() {
    let classes = [settingsStyles.settings_page, settingsStyles.default];

    // when we need to show addons
    let addons = this.props.currentCustomer.addons && this.props.currentCustomer.addons.length ? (<Fieldset legend='Applications Details' description={'Usage for Each App'}>
      <div className={settingsStyles.settingsBox}>
        <h3>Account</h3>
        <div>
          {this.props.currentCustomer.addons.map(i => {
            return (
              <div key="subscription-addon-{i.id}">
                <div>{addonTitles[i.id]}</div>
                <div>{i.quantity}</div>
                <div>{formatter.price(i.unit_price * i.quantity)}</div>
              </div>
            )
          })}
        </div>
      </div>
    </Fieldset>) : null

    let appsDetails = (
      <div>
        {
          // TODO: @pivanov - show addons from chargebee
          addons
        }
        <Fieldset legend='Applications Details' description={'Usage for Each App'}>
          {
            Object.keys(this.state.appsStats.stats).map((serviceName) => {
              let app = AppsManager.apps().find((i) => i.serviceName == serviceName) || {}
              return (
                <div key={'app-stats' + serviceName} className={[settingsStyles.settingsBox, settingsStyles.multiple].join(' ')}>
                  <AppBillingDetails app={app} stats={this.state.appsStats.stats[serviceName]} />
                </div>
              );
            })
          }

          <div className={[stylesEngine.legend, stylesEngine.appsDetails].join(' ')}>
            <p><span className={stylesEngine.starRed}>*</span> Prices exclude VAT</p>
            <p>
              <span className={stylesEngine.starBlue}>*</span>
              SashiDo offers <a href="https://blog.sashido.io/power-up-with-sashidos-brand-new-engine-feature/#discountsandbonuses" target="blank">Sustained use Discounts</a>. These discounts are auto-applied at the end of each billing cycle based on sustained Engine resources usage per app.
            </p>
          </div>
        </Fieldset>
      </div>
    );

    return (
      <div className={classes.join(' ')}>
        <Toolbar section={this.section} subsection={this.subsection}>
          <Button value='Go Back' onClick={this.onCloseClick.bind(this)} />
        </Toolbar>
        <PreLoader loading={this.state.loading}>
          <div className={settingsStyles.holder}>
            {appsDetails}
          </div>
        </PreLoader>
      </div>
    );
  }
}
